/**
 * Horizontal-scroll: desktop mouse wheel → горизонтальный скролл.
 *
 * Проблема: на десктопе обычная мышь даёт только deltaY. Без этого
 * хелпера юзер не может прокрутить горизонтальный слайдер колесом —
 * приходится shift+wheel или тач-pad. На мобиле проблем нет.
 *
 * Решение: одно document-level passive-false wheel-listener'е смотрим
 * есть ли под курсором горизонтальный скроллер (по селектору), и если
 * у него есть скролл вправо/влево — переводим deltaY в scrollLeft и
 * preventDefault на вертикальный скролл страницы.
 *
 * Селекторы добавляй сюда — это «реестр» горизонтальных слайдеров
 * проекта. Один список вместо разрозненных addEventListener в каждом
 * компоненте.
 */
(function () {
    'use strict';

    const SELECTORS = [
        '.models-slider',          // model-selector (popover + legacy section)
        '.profiles-selector',       // ProfilesSlider («Для кого создаём»)
        '.objects-selector',        // ObjectsSlider
        '.mods-grid',               // секция модов на главной
        '.launch-chips',            // chips в launch-bar (Нейросеть/Формат/...)
        '[data-horizontal-scroll]', // opt-in для нового кода
    ];

    /** Только десктоп. Тач-устройства игнорируем (там и так нормально). */
    function isDesktop() {
        // Coarse pointer = touch primary; mouse = fine. matchMedia
        // надёжнее чем UA-sniff: совпадает с реальным input.
        return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function findHorizontalScroller(target) {
        if (!target || target.nodeType !== 1) return null;
        for (const sel of SELECTORS) {
            const el = target.closest(sel);
            if (el && el.scrollWidth > el.clientWidth + 1) {
                return el;
            }
        }
        return null;
    }

    function onWheel(event) {
        // Если юзер уже скроллит горизонтально (shift+wheel / touchpad) —
        // не вмешиваемся, дефолт справится.
        if (event.deltaX !== 0) return;
        const scroller = findHorizontalScroller(event.target);
        if (!scroller) return;
        const dy = event.deltaY;
        if (dy === 0) return;
        // Преобразуем вертикальное колесо в горизонтальное.
        // deltaMode: 0 = pixel (norm), 1 = line (~16px), 2 = page.
        const px = event.deltaMode === 1 ? dy * 16
                 : event.deltaMode === 2 ? dy * scroller.clientWidth
                 : dy;
        // Если докрутили до края — пускаем дефолтный вертикальный скролл
        // страницы (чтобы не залипало внутри слайдера).
        const max = scroller.scrollWidth - scroller.clientWidth;
        const cur = scroller.scrollLeft;
        const next = cur + px;
        if ((px > 0 && cur >= max) || (px < 0 && cur <= 0)) {
            return;  // пускаем page-scroll
        }
        scroller.scrollLeft = Math.max(0, Math.min(max, next));
        event.preventDefault();
    }

    function init() {
        if (!isDesktop()) return;
        document.addEventListener('wheel', onWheel, { passive: false });
        console.log('[HorizontalScroll] ✅ Desktop wheel→scroll active');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Опционально для отладки / расширения.
    window.HorizontalScroll = { selectors: SELECTORS };
})();
